'use strict';

module.exports = {

    token: null,

    getUrl() {
        return Odigeo.Settings.getProperty('bookingApiUrlFormatter')('getBooking');
    },

    getMethod: Odigeo._.constant('POST'),

};
